import httpCommon from "./http-common";

// Get product service
const getProductService = (publicId: string) => {
  return httpCommon.get(`/v1/get/productService/${publicId}`);
};

const getProductServiceAsAdmin = () => {
  return httpCommon.get("/v1/admin/get/productService");
};

// Get all product services
const getAllProductServices = (businessId: number) => {
  return httpCommon.get(`/v1/get/productServices/${businessId}`);
};

const getAllProductServicesAsAdmin = () => {
  return httpCommon.get("/v1/admin/get/productServices");
};

// Get product services by currency
const getAllProductServicesByCurrency = (businessId: number, currency: string) => {
  return httpCommon.get(`/v1/get/productServicesAndCurrency/${businessId}/${currency}`);
};

const searchProductService = (businessId: number, searchTerm: string) => {
  return httpCommon.get(`/v1/search/productServices/${businessId}/${searchTerm}`);
};

// Add product service
const addProductService = (businessId: number, data: any) => {
  return httpCommon.post(`/v1/add/productService/${businessId}`, data);
};

// Update specific product service
const updateSpecificProductService = (publicId: string, data: any) => {
  return httpCommon.put(`/v1/update/productService/${publicId}`, data);
};

// Delete product service
const deleteProductService = (id: number) => {
  return httpCommon.delete(`/v1/delete/productService/${id}`);
};

const ProductService = {
  getProductService,
  searchProductService,
  getProductServiceAsAdmin,
  getAllProductServices,
  getAllProductServicesAsAdmin,
  getAllProductServicesByCurrency,
  addProductService,
  updateSpecificProductService,
  deleteProductService
};
export default ProductService;